import React from "react";
import { Reveal } from "./Reveal";
type Props = {
  eyebrow?: string;
  title: React.ReactNode;
  lead?: string;
  align?: "left" | "split";
  action?: React.ReactNode;
};
export function SectionHeading({
  eyebrow,
  title,
  lead,
  align = "left",
  action
}: Props) {
  if (align === "split") {
    return <Reveal className="mb-[clamp(2.5rem,4vw,5rem)] grid gap-6 lg:grid-cols-[1.2fr_1fr] lg:items-end" data-id="element-479" data-mp="ryj4jw8i61pi">
        <div data-id="element-480" data-mp="mzq1yyur7v44">
          {eyebrow && <p className="t-eyebrow mb-5 flex items-center gap-3 text-accent-soft" data-id="element-481" data-mp="mzzilvtwspx5"><span className="h-1.5 w-1.5 rounded-full bg-accent" data-id="element-482" data-mp="i6wxmc376osk" />{eyebrow}</p>}
          <h2 className="t-h2 max-w-[18ch]" data-id="element-483" data-mp="d8bw89c7lz2j">{title}</h2>
        </div>
        <div className="flex flex-col items-start gap-6 lg:items-end lg:text-right" data-id="element-484" data-mp="d6inmoi1d4rw">
          {lead && <p className="t-lead max-w-[46ch] text-muted" data-id="element-485" data-mp="87pch2q81puw">{lead}</p>}
          {action}
        </div>
      </Reveal>;
  }
  return <Reveal className="mb-[clamp(2.5rem,4vw,5rem)]" data-id="element-486" data-mp="3vdydeu55a592">
      {eyebrow && <p className="t-eyebrow mb-5 flex items-center gap-3 text-accent-soft" data-id="element-487" data-mp="3vgkt5h26vr2d"><span className="h-1.5 w-1.5 rounded-full bg-accent" data-id="element-488" data-mp="1dyzqwliccyzs" />{eyebrow}</p>}
      <h2 className="t-h2 max-w-[20ch]" data-id="element-489" data-mp="1irj1rapn9g0w">{title}</h2>
      {lead && <p className="t-lead mt-6 max-w-[56ch] text-muted" data-id="element-490" data-mp="1it3vwz81qwy8">{lead}</p>}
      {action && <div className="mt-8" data-id="element-491" data-mp="151pcira88tqn">{action}</div>}
    </Reveal>;
}